/** Fotos da loja: álbuns e o envio das fotos. */

import { api } from './client';
import type { AlbumDeFotos, AlbumDetalhe, FotoDoAlbum } from '../types';

const buscar = async <T,>(url: string): Promise<T> => (await api.get<T>(url)).data;

export interface DadosDoAlbum {
  nome?: string;
  descricao?: string | null;
  /** ISO; `null` limpa a data. */
  data_referencia?: string | null;
  capa_foto_id?: number | null;
}

export const ApiFotos = {
  albuns: () => buscar<AlbumDeFotos[]>('/fotos/albuns'),
  album: (id: number) => buscar<AlbumDetalhe>(`/fotos/albuns/${id}`),

  criarAlbum: async (dados: { nome: string; descricao?: string | null; data_referencia?: string | null }) =>
    (await api.post<AlbumDeFotos>('/fotos/albuns', dados)).data,
  editarAlbum: async (id: number, dados: DadosDoAlbum) =>
    (await api.patch<AlbumDeFotos>(`/fotos/albuns/${id}`, dados)).data,
  excluirAlbum: async (id: number): Promise<void> => {
    await api.delete(`/fotos/albuns/${id}`);
  },

  /** Uma foto por chamada: a tela manda algumas em paralelo e mostra o
   *  andamento de cada uma, e a recusada não derruba as outras. */
  enviarFoto: async (albumId: number, arquivo: File, aoProgredir?: (fracao: number) => void) => {
    const corpo = new FormData();
    corpo.append('arquivo', arquivo);
    return (
      await api.post<FotoDoAlbum>(`/fotos/albuns/${albumId}/fotos`, corpo, {
        // Foto de câmera em 4G passa fácil dos 30 s padrão do cliente.
        timeout: 300_000,
        onUploadProgress: (e) => {
          if (aoProgredir && e.total) aoProgredir(Math.min(1, e.loaded / e.total));
        },
      })
    ).data;
  },
  legendar: async (id: number, legenda: string | null) =>
    (await api.patch<FotoDoAlbum>(`/fotos/${id}`, { legenda })).data,
  excluirFoto: async (id: number): Promise<void> => {
    await api.delete(`/fotos/${id}`);
  },
  /** A foto grande como blob, para o Baixar dar nome ao arquivo. */
  baixar: async (id: number): Promise<Blob> =>
    (await api.get<Blob>(`/fotos/${id}/arquivo`, { responseType: 'blob', timeout: 120_000 })).data,
};
